import "../../../assets/UFC_DC_RF_V1/scss/modules/custom.scss";
import "../../../assets/UFC_DC_RF_V1/scss/modules/anim.scss";

import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import FbViewPixel from "../../../Utility/FbViewPixel";
import Footer from "../../Includes/Layouts/UFC_DC_V2/Footer";
import Form_UFC_DC_RF_V1 from "../../Forms/Form_UFC_DC_RF_V1";

const UFC_DC_RF_V1 = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="UFC_DC_RF_V1" />
      <FbViewPixel />
      <div className="UFC_DC_RF_V1">
        <Form_UFC_DC_RF_V1 />
        <Footer />
      </div>
    </>
  );
};

export default UFC_DC_RF_V1;
